import { render, staticRenderFns } from "./SVC00001.vue?vue&type=template&id=b8eb52ce&"
import script from "./SVC00001.vue?vue&type=script&lang=js&"
export * from "./SVC00001.vue?vue&type=script&lang=js&"
import style0 from "./SVC00001.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports